import * as React from 'react';

import { isNotEmptyObject } from '@impuls-coach/util-is';
import Image from 'components/atoms/Image';
import { ImageProps } from 'components/atoms/Image';

export type ThirdPartyLogoPropsType = {
	thirdPartyLogo?: ImageProps;
};

const ThirdPartyLogo = ({ thirdPartyLogo }: ThirdPartyLogoPropsType) => {
	if (!isNotEmptyObject(thirdPartyLogo)) {
		return null;
	}
	const imageProps = { ...thirdPartyLogo, ...{ modifier: 'fit-parent' } };
	return (
		<div className="m-card__logo-third-party">
			<Image {...(imageProps as any)} />
		</div>
	);
};

ThirdPartyLogo.displayName = 'Card(ThirdPartyLogo)';

export default ThirdPartyLogo;
